module.exports = {"title":"1:1 Inquiry","inquiryButton":"New Inquiry","typePlaceholder":"Type","searchInputPlaceholder":"Enter a search term.","searchWordPlaceholder":"Enter a search term","writerPlaceholder":"Author","selectAllOption":"Select All","checkingOnly":"Show posts in review only","replyStatus":"Reply Status","type":"Type","postTitle":"Title","writer":"Author","date":"Date","answered":"Answered","checking":"In Review","noPosts":"No posts found.","prev":"Prev","next":"Next","more":"More","typeService":"Service","typeEvent":"Event","typeUpdate":"Update","golfClubCount":"Golf Club ({n})"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/cs101.json
// module id = /06H
// module chunks = 2